import { useContext } from "react"

import { cn } from "@productlane/lib/src/browser"

import { SortIcon } from "@/screens/app/nav-icons"
import {
	settingsNavGroupClass,
	SettingsNavRow,
} from "./settings-pages/settings-nav-row"
import { SettingsCardInsetContext } from "./settings-switches/settings-container"

export const PortalSettingsCard = ({ dimmed }: { dimmed?: boolean }) => {
	const inset = useContext(SettingsCardInsetContext)
	return (
		<div
			className={cn(
				settingsNavGroupClass,
				"my-4",
				!inset && "sm:mx-0",
				dimmed && "opacity-50",
			)}
		>
			<SettingsNavRow
				icon={SortIcon}
				title="Portal settings"
				description="Set up SSO, custom domain, theme and a private portal."
				link="/settings/portal"
			/>
		</div>
	)
}
